import { render } from "./Parametres.vue?vue&type=template&id=34568374"
import script from "./Parametres.vue?vue&type=script&lang=js"
export * from "./Parametres.vue?vue&type=script&lang=js"

import "./Parametres.vue?vue&type=style&index=0&id=34568374&lang=css"

import exportComponent from "D:\\fclinique\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__